import React from "react";

class VersionChecker extends React.Component {
  componentDidMount() {
    // Temporarily disabled to prevent reload loops
    // this.checkForNewVersion();
    // this.interval = setInterval(this.checkForNewVersion, 5 * 1000);
    // document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  }

  handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      this.checkForNewVersion();
    }
  };

  checkForNewVersion = async () => {
    try {
      const response = await fetch(`/version.json?ts=${Date.now()}`, {
        cache: "no-store",
      });
      const { buildVersion } = await response.json();
      const currentVersion = localStorage.getItem("buildVersion");

      if (currentVersion && currentVersion !== buildVersion) {
        // console.log("🔄 New version detected:", buildVersion);
        localStorage.setItem("buildVersion", buildVersion);

        if ("caches" in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map((name) => caches.delete(name)));
        }

        // Force a full reload immediately
        window.location.reload();
      } else if (!currentVersion) {
        localStorage.setItem("buildVersion", buildVersion);
      }
    } catch (error) {
      // console.error("Version check failed:", error);
    }
  };

  render() {
    return null; // invisible component
  }
}

export default VersionChecker;
